import {API_URL, apiPost} from '../api'
import {IFloating} from './getFloatings'

export const createFloating = async (data: IFloating) => {
    return await apiPost(API_URL, 'admin/floating', data)
}
